import ActionManager from "./base";
import {
  updateAccountStart,
  updateAccountSuccess,
  updateAccountInvalid,
  updateAccountError,
  signOutStart,
  signOutEnd,
} from "../actions/account";
import {
  userFetchStart,
  userFetchSuccess,
  userFetchFail,
  USER_ATTRIBUTE,
  USER_ADD_ROLE,
} from "../actions/user";
import userAPI from "../api/user";
import { userLogout } from "../actions/user";
import UserStore from "../lib/user_store";
import DefaultActionManager from "./default_action_manager";

export class FetchUserManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong fetching your user account. Please try again later.";
  }

  defaultPreCallActionCreator() {
    return userFetchStart;
  }

  defaultSuccessActionCreator() {
    return userFetchSuccess;
  }
  defaultErrorActionCreator() {
    return userFetchFail;
  }
  response400(dispatch, json) {
    return this.responseError(dispatch, 400, json);
  }
  execute() {
    return userAPI.fetchUser(this.args.userUUID, this.args.authToken);
  }
}

export class SignOutActionManager extends ActionManager {
  preCall(dispatch) {
    dispatch(signOutStart());
  }

  finishCall(dispatch) {
    UserStore.remove();
    dispatch(signOutEnd());
    dispatch(userLogout());
    window.location.href = this.args.signOutRedirect || "/";
  }

  responseOK(dispatch, json) {
    this.finishCall(dispatch);
  }

  response400(dispatch, json) {
    this.finishCall(dispatch);
  }

  response403(dispatch, json) {
    this.finishCall(dispatch);
  }

  responseError(dispatch, statusCode, json) {
    this.finishCall(dispatch);
  }

  catchError(dispatch, err) {
    this.finishCall(dispatch);
  }

  defaultErrorMessage() {
    return "Uh oh, something went wrong signing out. Please try again later.";
  }
}

export class AccountUpdateActionManager extends ActionManager {
  execute() {
    return userAPI.update(this.args.userForm, this.args.existingUser);
  }

  responseOK(dispatch, json) {
    if (this.args.skipStore) {
      json = { isSuccess: true };
    } else {
      UserStore.save(json);
    }
    dispatch(updateAccountSuccess(json));

    if (this.args.customSuccess) {
      this.showSuccess(dispatch, this.args.customSuccess);
    } else {
      this.showSuccess(dispatch, "Account update saved.");
    }
  }

  defaultErrorMessage() {
    return "Uh oh, something went wrong updating your account. Please try again later.";
  }

  defaultPreCallActionCreator() {
    return updateAccountStart;
  }

  defaultSuccessActionCreator() {
    return updateAccountSuccess;
  }

  default400ActionCreator() {
    return updateAccountInvalid;
  }

  defaultErrorActionCreator() {
    return updateAccountError;
  }
}

export const updatePassword = (newPassword, user, skipStore) =>
  new AccountUpdateActionManager({
    userForm: { password: newPassword },
    existingUser: user,
    skipStore,
  }).run();

export function setUserAttribute(key, value) {
  if (UserStore.isAdminLogin()) {
    // eslint-disable-next-line
    console.log("User Attribute Not Set for Admin Login. Would have set:", key, value);
    return { type: "NO_ACTION" };
  }
  return new DefaultActionManager({
    auth: true,
    route: "users/me/set-attribute",
    actionName: USER_ATTRIBUTE,
    method: "POST",
    body: {
      key,
      value,
    },
  }).run();
}

export function addRole(user, role) {
  return newAddRoleActionManger(user, role).run();
}

// Only use this if you want to chain requests.
export function addRoleFetch(user, role, dispatch, getState) {
  return newAddRoleActionManger(user, role).execute(dispatch, () => {
    return {
      user: { user },
    };
  });
}

function newAddRoleActionManger(user, role) {
  return new DefaultActionManager({
    auth: true,
    route: `users/${user.uuid}/add-role`,
    actionName: USER_ADD_ROLE,
    method: "POST",
    body: {
      role,
    },
  });
}
